// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"Q7-z"};